import { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModal } from "../../store/actions/modalAction";
import { callApiAction } from "../../store/actions/commonAction";
import { Delete, Edit } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import MessageDilog from "../../components/texts/MessageDilog";
import ProductSubCategoryMainUi from "./ProductSubCategoryMainUi";
import { deleteProductSubCategoryApi } from "../../apis/productSubCategory.api";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { fetchProductSubCategoryAction } from "../../store/actions/setting.Action";
import ProductSubCategoryCreateController from "./ProductSubCategoryCreateController";
import MODULES from "../../utils/module.constant";
import CommonActionComponent from "../../components/CommonActionComponent";

const ActionComponent = memo(({ params, setParams }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { settings } = useSelector((state) => state);

  const onEdit = () => {
    dispatch(
      openModal(
        <ProductSubCategoryCreateController id={params._id} />,
        "sm",
        false,
        "updateproductsubcategory",
      ),
    );
  };

  const deleteFun = async (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await deleteProductSubCategoryApi({ id: params._id }),
        (response) => {
          setParams({});
          setLoading(false);
          dispatch(
            callSnackBar(
              params.name + " Deleted Successfully",
              SNACK_BAR_VARIETNS.suceess,
            ),
          );
          dispatch(
            fetchProductSubCategoryAction(settings.productSubCategory_filters),
          );
          dispatch(closeModal("messagedialog"));
        },
        (err) => {
          setLoading(false);
        },
      ),
    );
  };

  const onDelete = () => {
    dispatch(
      openModal(
        <MessageDilog
          onSubmit={deleteFun}
          title="Alert!"
          modalId="messagedialog"
          message={`Are you sure to delete "${params.name || params.title}" ?`}
        />,
        "sm",
        false,
        "messagedialog",
      ),
    );
  };

  return (
    <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
      <IconButton size="inherit" onClick={onEdit}>
        <Edit color="info" fontSize="inherit" />
      </IconButton>
      <IconButton disabled={loading} size="inherit" onClick={onDelete}>
        <Delete color="error" fontSize="inherit" />
      </IconButton>
    </Box>
  );
});

const ProductSubCategoryMainController = () => {
  const dispatch = useDispatch();
  const title = "Product Sub Category";
  const deleteApi = deleteProductSubCategoryApi;
  const { settings, user } = useSelector((state) => state);
  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ["name"],
    sort: "",
    sortDirection: -1,
  });

  const columns = useMemo(
    () => [
      {
        id: 1,
        fieldName: "name",
        label: "Name",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => (
          <Typography textTransform="capitalize">{params.name}</Typography>
        ),
      },
      {
        id: 2,
        fieldName: "parameters",
        label: "Parameters",
        align: "left",
        sort: false,
        renderValue: (params, setParams) => (
          <Typography variant="body2">
            {params.parameters && params.parameters.length > 0
              ? params.parameters.join(", ")
              : "-"}
          </Typography>
        ),
      },
      {
        id: 5,
        fieldName: "",
        label: "Action",
        align: "right",
        hide:
          user?.data?.ims_modules?.find(
            (item) => item.module === MODULES.PRODUCT_SUB_CATEGORY,
          )?.actions?.length === 0
            ? true
            : false,
        renderValue: (params, setParams) => (
          <CommonActionComponent
            DeleteMessage={`Are you sure to delete "${params.name || params.title}" ?`}
            DeleteApi={deleteApi}
            modalkey={"updateproductsubcategory"}
            EditComponent={ProductSubCategoryCreateController}
            params={params}
            setParams={setParams}
            ModuleMatch={MODULES.PRODUCT_SUB_CATEGORY}
            callBack={() => dispatch(fetchProductSubCategoryAction(filters))}
          />
        ),
      },
    ],
    [user, dispatch, filters],
  );

  const onCreateClick = () => {
    dispatch(
      openModal(
        <ProductSubCategoryCreateController />,
        "sm",
        false,
        "createproductsubcategory",
      ),
    );
  };

  useEffect(() => {
    dispatch(fetchProductSubCategoryAction(filters));
  }, [filters, dispatch]);

  return (
    <ProductSubCategoryMainUi
      columns={columns}
      onCreateClick={onCreateClick}
      title={title}
      loading={settings.productSubCategory_loading}
      state={settings.productSubCategory_data}
      filters={filters}
      setFilters={setFilters}
    />
  );
};

export default ProductSubCategoryMainController;
